import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class GovernorateService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  GetGovernorate():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Governorate/Get`);
  }

  DeleteGovernorate(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Governorate/Delete?id=${id}`);
  }

  CreateGovernorate(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Governorate/Create`,data);
  }
  UpdateGovernorate(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Governorate/Update`,data)
  }
}
